import {
  FiltersParamsType,
  ProductCountOptionsEnum,
} from 'domains/Orders/Orders/ordersService';

export function useProductUnitsCountFilter() {
  const isProductsCountFilterValid = (values: FiltersParamsType): boolean =>
    !!values.minUnits && !!values.maxUnits
      ? Number(values.minUnits) <= Number(values.maxUnits)
      : true;

  const getProductsCountFilterOption = (
    minUnits: string,
    maxUnits: string,
  ): ProductCountOptionsEnum => {
    if (minUnits === '' && maxUnits === '') {
      return ProductCountOptionsEnum.ALL;
    }
    if (minUnits === maxUnits) {
      return ProductCountOptionsEnum.EXACT_NUMBER;
    }
    return ProductCountOptionsEnum.RANGE;
  };

  const sanitizeProductUnitsCountFilter = (
    option: ProductCountOptionsEnum,
    minUnits: string,
    maxUnits: string,
  ): {
    selectedOption: ProductCountOptionsEnum;
    minUnits: string;
    maxUnits: string;
  } => {
    if (option === ProductCountOptionsEnum.EXACT_NUMBER && minUnits === '0') {
      return {
        selectedOption: option,
        minUnits: '1',
        maxUnits: '1',
      };
    }
    if (
      option === ProductCountOptionsEnum.RANGE &&
      minUnits === '0' &&
      maxUnits === ''
    ) {
      return {
        selectedOption: option,
        minUnits: '1',
        maxUnits: '',
      };
    }
    const newValue = {
      selectedOption:
        minUnits === '' && maxUnits === ''
          ? ProductCountOptionsEnum.ALL
          : option,
      minUnits:
        (minUnits === '' || minUnits === '0') && maxUnits !== ''
          ? '1'
          : minUnits,
      maxUnits: maxUnits,
    };
    return newValue;
  };

  return {
    isProductsCountFilterValid,
    getProductsCountFilterOption,
    sanitizeProductUnitsCountFilter,
  };
}
